var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4982 2.72325C23.2216 1.69 22.4096 0.878009 21.3763 0.60142C19.5055 0.0996095 12 0.0996094 12 0.0996094C12 0.0996094 4.49456 0.0996095 2.62364 0.60142C1.59039 0.878009 0.778399 1.69 0.501811 2.72325C1.50211e-07 4.59417 0 8.5 0 8.5C0 8.5 1.50211e-07 12.4058 0.501811 14.2768C0.778399 15.31 1.59039 16.122 2.62364 16.3986C4.49456 16.9004 12 16.9004 12 16.9004C12 16.9004 19.5055 16.9004 21.3763 16.3986C22.4096 16.122 23.2216 15.31 23.4982 14.2768C24 12.4058 24 8.5 24 8.5C24 8.5 23.998 4.59417 23.4982 2.72325Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59766 12.0996L15.8328 8.50002L9.59766 4.90039V12.0996Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a5757074823376ef81c9ee87c338c3d9.svg";
export { ForwardRef as ReactComponent };